export const JSON_CONTENT = { 'Content-Type': 'application/json' }
export const POLLING_TIME = 10 * 1000
export const SUCCESS_BRIEF_CODE = 1
